import classNames from 'classnames';
import React from 'react';
import styles from './MenuIcon.less';

interface MenuIconProps {
  isOpen: boolean;
}

export const MenuIcon: React.FunctionComponent<MenuIconProps> = ({
  isOpen,
}) => (
  <div className={classNames(styles.menuIcon, { [styles.isOpen]: isOpen })}>
    <span></span>
    <span></span>
    <span></span>
  </div>
);
